<div class = "title">
    {{ data.file.name | prefixWithDots: 40 }} előnézete
</div>
<div>
    <app-videojs-player [options] = "videoJsPlayerOptions"></app-videojs-player>
</div>
